import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrNE: CultureInfo = {
  name: 'fr-NE',
  displayName: 'français (Niger)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-NE',
  parent: CultureInfoFr
};
